module.exports = __webpack_public_path__ + "media/icons/delete-3cfac411.png";